import { z } from 'zod';
import { c } from '../../contract';
import { InviteErrorReasons } from '../../types/FamilyPlan';

export const familyPlanRouter = c.router(
  {
    getOrGenerateFamilyPlan: {
      summary: 'Get or Generate Family Plan',
      method: 'GET',
      path: '/plan-details',
      query: z.object({
        countryCode: z.string().optional(),
      }),
      responses: {
        200: z
          .object({
            userId: z.string(),
            familyPlanCountry: z.string(),
            limit: z.number(),
            familyJoinCode: z.string(),
          })
          .optional(),
      },
    },

    getPlanMembers: {
      summary: 'Get Family Plan members',
      method: 'GET',
      path: '/members',
      responses: {
        200: z.array(
          z.object({
            displayName: z.string(),
            avatar: z.string().optional(),
            userId: z.string(),
          }),
        ),
      },
    },

    inviteAcceptCheck: {
      summary: 'Check if user can accept invite',
      method: 'POST',
      path: '/invite-accept-check',
      body: z.object({
        familyJoinCode: z.string(),
        country: z.string(),
      }),
      responses: {
        200: z.discriminatedUnion('canAcceptInvite', [
          z.object({ canAcceptInvite: z.literal(true) }),
          z.object({
            canAcceptInvite: z.literal(false),
            reason: z.enum(InviteErrorReasons),
          }),
        ]),
      },
    },

    acceptInvite: {
      summary: 'Accept invite',
      method: 'POST',
      path: '/accept-invite',
      body: z.object({
        familyJoinCode: z.string(),
        country: z.string(),
      }),
      responses: {
        200: z.boolean(),
      },
    },
  },
  { pathPrefix: '/family-plan' },
);
